export const RESET = 'EXSBDOCUMENT_LIST_RESET'
export const SET_ITEMS = 'EXSBDOCUMENT_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBDOCUMENT_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBDOCUMENT_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBDOCUMENT_LIST_TOGGLE_LOADING'
